export enum Paths {
  platformRoles = '/platform-roles',
  authorizationDecisions = '/authorization-decisions',
  billingAccounts = '/billing-accounts',
  home = '/',
  login = '/login',
  profiles = '/profiles',
  signupRequests = '/signup-requests',
  companies = '/companies',
  companiesStats = '/companies/stats',
  tags = '/tags',
  mediaLibraryTags = '/ml-tags',
  deliveries = '/deliveries',
  usages = '/usages',
  templates = '/templates',
  pricingPlans = '/pricing-plans',
  emailNotifications = '/email-notifications',
  integrationDefinitions = '/integration-definitions',
  deletionRequests = '/deletion-requests',
  settings = '/settings',
  controlSettings = '/settings/control',
  contentSettings = '/settings/content',
}
